// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ProjectsView {\n  text-align: center;\n  margin: 0;\n  padding: 0;\n  width: 100vw;\n  height: 100vh;\n}", ""]);
// Exports
module.exports = exports;
